import { DataTableColumn } from "../../../shared/components/data-table/DataTableColumn.model";

export interface BadGuest {
    id: number;
    reference_id: any;
    first_name: string;
    middle_name: string;
    last_name: string;
    email: string;
    phone: string;
    address_id: number;
    address: BadGuestAddress;
    birth_date: string;
    ssn: string;
    drivers_license: string;
    national_number: any;
    note: string;
    is_active: number;
}

export interface BadGuestAddress {
    address_id: number;
    address_line_1: string;
    address_line_2: string;
    city: string;
    state: string;
    postal_code: string;
    country_id: number;
    country_name: string;
    is_validated: boolean;
}

export const BadGuestsColumns: DataTableColumn[] = [
    { column: 'full_name', display: 'Full Name' },
    { column: 'birth_date', display: 'Birthdate' },
    { column: 'address_line_1', display: 'Address' },
    { column: 'city', display: 'City' },
    { column: 'state', display: 'State' },
    { column: 'postal_code', display: 'Postal Code' },
    { column: 'country_code', display: 'Country' },
    { column: 'badGuestButtons', display: '' }
]